import { render, staticRenderFns } from "./BenefitsForYou.vue?vue&type=template&id=b076a896"
import script from "./BenefitsForYou.vue?vue&type=script&lang=js"
export * from "./BenefitsForYou.vue?vue&type=script&lang=js"
import style0 from "./BenefitsForYou.vue?vue&type=style&index=0&id=b076a896&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports